exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-fixed thead {\n  width: 97%;\n}\n.table-fixed tbody {\n  height: 230px;\n  overflow-y: auto;\n  width: 100%;\n}\n\n.table-fixed thead, .table-fixed tbody, .table-fixed tr, .table-fixed td, .table-fixed th {\n  display: block;\n}\n/*.table-fixed tbody td, .table-fixed thead > tr> th {*/\n  /*float: left;*/\n  /*border-bottom-width: 0;*/\n/*}*/\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/src/app/profile/profile.component.css
// module id = ../../../../../src/app/profile/profile.component.css
// module chunks = 1